exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".numberBtn .ivu-input-number-handler-wrap{display:none}", ""]);

// exports
